// extracted by mini-css-extract-plugin
export default {"Main":"StickyAlert_Main__YUe3V","Link":"StickyAlert_Link__LdBCy","CloseButton":"StickyAlert_CloseButton__WBSx+"};